export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=803de04e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/requests/view/index.vue?vue&type=template&id=803de04e&
// module id = 1391
// module chunks = 0